//export const url = "https://api-new.requal.in/api";
//export const web_url = "https://api-new.requal.in/api";
//export const IMAGE_URL = "https://api-new.requal.in/api/image/upload-image";
//export const url = "http://localhost:3003/api";
// NOTE: Pointed at the DEVELOPMENT backend. Switch to the
// "https://api-new.requal.in/api" lines above before deploying to production.
export const url = "https://lc-backend.requal.in/api";
export const web_url = "https://lc-user.requal.in";
export const IMAGE_URL = "https://lc-backend.requal.in/api/image/upload-image";
